import { TrendingUp, FileText, Users, ArrowUpRight, DollarSign, Handshake } from 'lucide-react';
import SectionReveal from './SectionReveal';

const iconList = [TrendingUp, FileText, Users, ArrowUpRight, DollarSign, Handshake];
const FINANCE_IMG = "https://images.unsplash.com/photo-1758518727613-00192aed759b?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjAzMzV8MHwxfHNlYXJjaHwyfHxjb3Jwb3JhdGUlMjBib2FyZHJvb20lMjBmaW5hbmNlfGVufDB8fHx8MTc3NDc5NzI3N3ww&ixlib=rb-4.1.0&q=85";

function FeatureCard({ feature, Icon }) {
  return (
    <div className="group bg-[#111111] border border-white/10 p-7 hover:border-[#D4A017]/35 hover:-translate-y-1 transition-all duration-300 h-full">
      <div className="flex items-start gap-4">
        <div className="flex-shrink-0 w-10 h-10 flex items-center justify-center text-[#D4A017] border border-[#D4A017]/25 group-hover:bg-[#D4A017]/10 transition-colors duration-200">
          <Icon size={17} />
        </div>
        <div>
          <h3 className="text-base font-medium text-white mb-2" style={{ fontFamily: "'Outfit', sans-serif" }}>{feature.title}</h3>
          <p className="text-sm text-white/55 leading-relaxed">{feature.body}</p>
        </div>
      </div>
    </div>
  );
}

export default function FinancingSection({ text }) {
  return (
    <section id="financing" className="py-24 sm:py-32 bg-[#050505]">
      <div className="container mx-auto px-6 lg:px-12 max-w-7xl">
        <SectionReveal>
          <div className="mb-16">
            <p className="text-xs tracking-[0.28em] uppercase text-[#D4A017] mb-4 font-medium">{text.label}</p>
            <h2 className="text-3xl sm:text-4xl lg:text-5xl font-medium text-white mb-5 max-w-3xl" style={{ fontFamily: "'Outfit', sans-serif" }}>{text.title}</h2>
            <p className="text-base text-white/60 max-w-2xl leading-relaxed">{text.subtitle}</p>
          </div>
        </SectionReveal>
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-5 mb-12">
          {text.features.map((feature, i) => {
            const Icon = iconList[i % iconList.length];
            return (
              <SectionReveal key={feature.title} delay={i * 80}>
                <FeatureCard feature={feature} Icon={Icon} />
              </SectionReveal>
            );
          })}
        </div>
        <SectionReveal delay={350}>
          <div className="relative overflow-hidden">
            <img src={FINANCE_IMG} alt="Project Financing" className="w-full h-64 sm:h-80 object-cover" />
            <div className="absolute inset-0 bg-gradient-to-r from-black/88 via-black/60 to-black/20" />
            <div className="absolute inset-0 flex items-center px-8 sm:px-14">
              <p className="text-3xl sm:text-4xl font-medium text-white leading-tight" style={{ fontFamily: "'Outfit', sans-serif" }}>
                €550M in structured<br /><span className="text-[#D4A017]">energy transactions</span>
              </p>
            </div>
          </div>
        </SectionReveal>
      </div>
    </section>
  );
}
